import { LoopOnce } from "three";
import { AnimationDirection } from "@rendering/vortex-core";
export class ModelAnimation {
  constructor(mixer, clip, options, tags) {
    Object.defineProperty(this, "completionStatus", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "activeStatus", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "canceledStatus", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "myTags", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "mixer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "animation", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "options", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "animationFinished", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.mixer = mixer;
    this.animation = this.buildAnimation(mixer, clip, options.duration);
    this.options = options;
    this.myTags = tags || [];
    this.animationFinished = new Promise(resolve => {
      this.mixer.addEventListener("finished", () => {
        this.completionStatus = true;
        this.activeStatus = false;
        resolve();
      });
    });
  }
  get isComplete() {
    return this.completionStatus;
  }
  get isActive() {
    return this.activeStatus;
  }
  get tags() {
    return this.myTags;
  }
  get isCanceled() {
    return this.canceledStatus;
  }
  resetMeshState() {
    this.animation.reset();
  }
  update(delta) {
    this.mixer.update(delta);
  }
  start() {
    this.activeStatus = true;
    if (this.options.direction === AnimationDirection.forward) {
      this.playAnimationForward();
    } else {
      this.playAnimationBackward();
    }
    return this.animationFinished;
  }
  stop() {
    this.animation.paused = true;
    this.activeStatus = false;
  }
  cancel() {
    this.canceledStatus = true;
    this.resetMeshState();
  }
  resume() {
    this.activeStatus = true;
    this.animation.paused = false;
  }
  // eslint-disable-next-line class-methods-use-this
  buildAnimation(mixer, clip, duration) {
    const animation = mixer.clipAction(clip);
    if (duration !== undefined) {
      animation.setDuration(duration);
    }
    animation.setLoop(LoopOnce, 1);
    animation.play();
    return animation;
  }
  playAnimationForward() {
    this.resetMeshState();
    this.animation.setEffectiveTimeScale(Math.abs(this.animation.timeScale));
    this.animation.clampWhenFinished = true;
  }
  playAnimationBackward() {
    if (this.animation.time === 0) {
      this.animation.time = this.animation.getClip().duration;
    }
    this.resume();
    this.animation.setEffectiveTimeScale(-Math.abs(this.animation.timeScale));
  }
}